export default "__VITE_ASSET__baa8c609__"